
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/timeline/books",
      function () {
        return require("private-next-pages/timeline/books.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/timeline/books"])
      });
    }
  